export function getFileName(headers: Headers): string {
  const contentDisposition = headers.get('content-disposition');

  if (!contentDisposition) {
    return '';
  }

  const contentDispositionFileName = 'filename=';

  const startOfSubstring =
    contentDisposition.indexOf(contentDispositionFileName) +
    contentDispositionFileName.length;
  const endOfSubstring = contentDisposition.indexOf(';', startOfSubstring);

  return contentDisposition.substring(startOfSubstring, endOfSubstring);
}
